import React, { Component } from "react";
import ReactExport from "assets/libs/react-export-excel";
import moment from "moment";
import _ from "lodash";
import Button from "@material-ui/core/Button";
import {
  fetchWeatherDate,
  fetchIpmants,
  fetchLoginIpman,
  fetchVoyageNoIpman
} from "../../api/portal";
import { withRouter } from "react-router-dom";

class Downloadexceltabtrack extends Component {
  constructor(props) {
    super(props);
    const { datanya, dataship } = this.props;
    this.state = {
      datanya: [],
      dataexcel: [],
      shipname: "",
      proccess: "",
      totaldata: 0,
      remaining: 0,
      voyageNumber: ""
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.datanya != nextProps.datanya) {
      this.setState({ dataexcel: [], remaining: 0 });
    }

    this.setState({
      datanya: nextProps.datanya,
      shipname: nextProps.dataship,
      totaldata: nextProps.datanya.length
    });
  }

  handleOnGenerate = () => {
    let databaru = [];
    let intremaining = 0;
    fetchLoginIpman()
      .then(response => {
      })
      .catch(error => {
        console.log(error);
        //this.props.history.push("/pages/login#logout");
      });
    this.state.datanya.map(e => {
      fetchWeatherDate(
        e.lon,
        e.lat,
        moment(e.date_created)
          .subtract(7, "hours")
          .format("YYYY-MM-DD:H"),
        moment(e.date_created)
          .subtract(6, "hours")
          .format("YYYY-MM-DD:H")
      )
        .then(response => {
          let weather = "Unknown";
          let temp = "-";
          let wind_speed = "";
          let wind_dir = "";

          if (
            typeof response.data.data[0].weather.description !== "undefined"
          ) {
            weather = response.data.data[0].weather.description;
            temp = response.data.data[0].temp;
            wind_speed = response.data.data[0].wind_spd;
            wind_dir = response.data.data[0].wind_dir;
          }
          weather = weather;
          temp = temp;
          let skalaBeaufort = "";

          if (wind_speed < 1) {
            skalaBeaufort = "Calm";
          } else if (wind_speed >= 1 && wind_speed <= 3) {
            skalaBeaufort = "Light Air";
          } else if (wind_speed >= 4 && wind_speed <= 6) {
            skalaBeaufort = "Light Breeze";
          } else if (wind_speed >= 7 && wind_speed <= 10) {
            skalaBeaufort = "Gentle Breeze";
          } else if (wind_speed >= 11 && wind_speed <= 16) {
            skalaBeaufort = "Moderate Breeze";
          } else if (wind_speed >= 17 && wind_speed <= 21) {
            skalaBeaufort = "Fresh Breeze";
          } else if (wind_speed >= 22 && wind_speed <= 27) {
            skalaBeaufort = "Strong Breeze";
          } else if (wind_speed >= 28 && wind_speed <= 33) {
            skalaBeaufort = "Near Gale";
          } else if (wind_speed >= 34 && wind_speed <= 40) {
            skalaBeaufort = "Gale";
          } else if (wind_speed >= 41 && wind_speed <= 47) {
            skalaBeaufort = "Strong Gale";
          } else if (wind_speed >= 48 && wind_speed <= 55) {
            skalaBeaufort = "Storm";
          } else if (wind_speed >= 56 && wind_speed <= 63) {
            skalaBeaufort = "Violent Storm";
          } else if (wind_speed >= 64) {
            skalaBeaufort = "Hurricane";
          }

          // fetchIpmants(
          //   //moment(e.date_created).format("YYYY-MM-DD HH:mm:ss"),
          //   moment(e.date_created)
          //     .subtract(7, "hours")
          //     .format("YYYY-MM-DD H:m:s"),
          //   moment(e.date_created)
          //     .subtract(6, "hours")
          //     .format("YYYY-MM-DD H:m:s"),
          //   e.call_sign
          // )
          //   .then(response => {
          intremaining++;
          this.setState({
            proccess: `Loading data ${intremaining}/${this.state.totaldata}... `
          });

          if (intremaining == this.state.totaldata) {
            this.setState({ proccess: "" });
          }

          // let voyage = response.data.results[0];
          // if (voyage) {
          //   this.setState({ voyageNumber: voyage.voyagenumber });
          //   databaru.push({
          //     date_created: moment(e.date_created).format(
          //       "DD/MM/YYYY HH:mm:ss"
          //     ),
          //     lon: parseFloat(e.lon).toFixed(4) + "º",
          //     lat: parseFloat(e.lat).toFixed(4) + "º",
          //     speed: (parseInt(e.speed) * 0.1).toFixed(2),
          //     weather: weather,
          //     temp: temp,
          //     wind_spd: wind_speed,
          //     wind_dir: wind_dir,
          //     skalaBeaufort: skalaBeaufort,
          //     voyageNumber: this.state.voyageNumber
          //   });

          //   let datasort = _.sortBy(databaru, function(e) {
          //     return e.date_created;
          //   });
          //   datasort.reverse();
          //   this.setState({ dataexcel: datasort });
          // } else {
          databaru.push({
            date_created: moment(e.date_created).format("DD/MM/YYYY HH:mm:ss"),
            lon: parseFloat(e.lon).toFixed(4) + "º",
            lat: parseFloat(e.lat).toFixed(4) + "º",
            speed: (parseInt(e.speed) * 0.1).toFixed(2),
            weather: weather,
            temp: temp,
            wind_spd: wind_speed,
            wind_dir: wind_dir,
            skalaBeaufort: skalaBeaufort
            // voyageNumber: 0
          });
          let datasort = _.sortBy(databaru, function(e) {
            return e.date_created;
          });
          datasort.reverse();
          this.setState({ dataexcel: datasort });
          // }
          // })
          // .catch(error => {
          //   console.log(error);
          // });

          // databaru.push({
          //   date_created: "",
          //   lon: "",
          //   lat: "",
          //   speed: "",
          //   weather: "",
          //   temp: "",
          //   wind_spd: "",
          //   wind_dir: "",
          //   skalaBeaufort: "",
          // });
        })
        .catch(error => {
          console.log(error);
          // this.props.history.push("/pages/login#logout");
        });
    });
  };

  componentDidMount() {}

  renderDataDownload = () => {
    // console.log(this.state.dataexcel.length);

    if (this.state.dataexcel.length != 0) {
      const ExcelFile = ReactExport.ExcelFile;
      const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
      const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

      return (
        <ExcelFile
          element={
            <Button color="primary" id="file-download">
              {this.state.proccess} Download Report
            </Button>
          }
          filename={this.state.shipname}
        >
          <ExcelSheet data={this.state.dataexcel} name="Sheet 1">
            <ExcelColumn label="Date Time" value="date_created" />
            <ExcelColumn label="Longitude" value="lon" />
            <ExcelColumn label="Latitude" value="lat" />
            <ExcelColumn label="Speed" value="speed" />
            <ExcelColumn label="Weather" value="weather" />
            <ExcelColumn label="Temperatur (C)" value="temp" />
            <ExcelColumn label="Wind Speed (Knot)" value="wind_spd" />
            <ExcelColumn label="Wind DIrection" value="wind_dir" />
            <ExcelColumn label="Skala (Beafort)" value="skalaBeaufort" />
            {/* <ExcelColumn label="Voyage Number" value="voyageNumber" /> */}
          </ExcelSheet>
        </ExcelFile>
      );
    } else {
      if (this.state.totaldata != 0) {
        return (
          <Button color="primary" onClick={this.handleOnGenerate}>
            Generate Report
          </Button>
        );
      } else {
        return false;
      }
    }
  };

  render() {
    // console.log(this.state.dataexcel);

    return <div>{this.renderDataDownload()}</div>;
  }
}

export default withRouter(Downloadexceltabtrack);
